import React, { useMemo } from 'react';
import { ApButtonSecondary } from '@alixpartners/ui-components';
import {
	HeaderItemName,
	HeaderItemOptions,
	HeaderItemToggle,
	HeaderRow,
	ActionWrapper,
	Wrapper,
	ListRow,
	ListToggleWrapper,
	ToggleSwitch,
	VerticalDivider,
	ListNameWrapper,
	IndexText,
	TextInput,
	ListColumnWrapper,
	Text,
} from './CustomColumns.styles';
import { Loader } from 'CategoryManagement/CategoryWidget/utils';

const CustomFilterItem = ({ data: filter, onChange, idx }) => {
	const { isActive, description, columnName } = filter;
	return (
		<ListRow>
			<ListToggleWrapper>
				<ToggleSwitch
					defaultChecked={isActive}
					onChange={() => {
						onChange({ ...filter, isActive: !isActive });
					}}
				/>
				<VerticalDivider />
			</ListToggleWrapper>
			<ListNameWrapper>
				<IndexText>{idx}</IndexText>
				<TextInput
					value={description}
					onChange={event => {
						onChange({ ...filter, description: event.target.value });
					}}
				/>
			</ListNameWrapper>
			<ListColumnWrapper>
				<Text>{columnName}</Text>
			</ListColumnWrapper>
		</ListRow>
	);
};

const CustomColumns = ({
	customColumns,
	isSavingOrFetchingColumns,
	setCustomColumns,
	onSaveCustomColumnsHandler,
	onClickNext,
}) => {
	const isAnyColumnUpdated = useMemo(
		() => customColumns.filter(x => x.isUpdated === true).length > 0,
		[customColumns]
	);

	return (
		<Wrapper>
			{isSavingOrFetchingColumns ? (
				<Loader />
			) : (
				<>
					<HeaderRow>
						<HeaderItemToggle>On/off</HeaderItemToggle>
						<HeaderItemOptions>Column Name</HeaderItemOptions>
						<HeaderItemName>Custom Column</HeaderItemName>
					</HeaderRow>
					{customColumns.map((filter, idx) => (
						<CustomFilterItem
							data={filter}
							idx={idx + 1}
							key={idx}
							onChange={filter => {
								const newFilters = [...customColumns];
								newFilters[idx] = filter;
								newFilters[idx].isUpdated = true;
								setCustomColumns(newFilters);
							}}
						/>
					))}
					<ActionWrapper>
						<ApButtonSecondary
							disabled={isAnyColumnUpdated}
							onClick={onClickNext}
						>
							Next
						</ApButtonSecondary>
						<ApButtonSecondary
							disabled={!isAnyColumnUpdated}
							onClick={onSaveCustomColumnsHandler}
						>
							Save & Next
						</ApButtonSecondary>
					</ActionWrapper>
				</>
			)}
		</Wrapper>
	);
};

export default CustomColumns;
